import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46b02b43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "extras"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { style: {"color":"gray","font-weight":"bold"} }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { style: {"color":"gray","font-weight":"bold"} }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { style: {"color":"gray","font-weight":"bold"} }, "Tavsiye süreci sona ermiştir. İlginiz için teşekkür ederiz.", -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "sharePickupPopup" }
const _hoisted_21 = {
  class: "mytitle md",
  style: {"padding":"0"}
}
const _hoisted_22 = { style: {"font-weight":"bold","font-size":"18px","color":"#4c4c4c"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  checked: "",
  style: {"transform":"scale(1.5)"}
}, null, -1))
const _hoisted_24 = { style: {"font-size":"20px","color":"rgb(52 135 205)","font-weight":"bold","margin-top":"15px"} }
const _hoisted_25 = { style: {"font-size":"12px","color":"gray","margin-bottom":"20px"} }
const _hoisted_26 = { style: {"font-size":"12px"} }
const _hoisted_27 = { style: {"margin-bottom":"10px"} }
const _hoisted_28 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_29 = { style: {"font-weight":"bold"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  checked: ""
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "175 TL", -1))
const _hoisted_32 = {
  key: 0,
  class: "inputs-items-row",
  style: {"align-items":"center","margin-top":"30px"}
}
const _hoisted_33 = {
  class: "form-element",
  style: {"margin-left":"0"}
}
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  class: "form-element",
  style: {"margin-top":"8px"}
}
const _hoisted_36 = {
  key: 1,
  class: "inputs-items-row",
  style: {"align-items":"center","margin-top":"30px"}
}
const _hoisted_37 = {
  class: "form-element",
  style: {"margin-left":"0","width":"initial"}
}
const _hoisted_38 = { style: {"margin":"0"} }
const _hoisted_39 = {
  class: "myformgroup",
  style: {"padding-top":"0"}
}
const _hoisted_40 = { class: "card-element" }
const _hoisted_41 = { class: "card-element" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "card-element-medium" }
const _hoisted_44 = { class: "card-element medium" }
const _hoisted_45 = { class: "card-element medium" }
const _hoisted_46 = {
  style: {"font-weight":"bold","margin":"15px 0px 20px","display":"block"},
  ref: "chkHizmetKabul"
}
const _hoisted_47 = {
  key: 2,
  class: "payment-error"
}
const _hoisted_48 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_49 = { class: "sharePickupPopup" }
const _hoisted_50 = {
  class: "mytitle md",
  style: {"padding":"0"}
}
const _hoisted_51 = { style: {"font-size":"20px","color":"rgb(52 135 205)","font-weight":"bold","margin-top":"15px"} }
const _hoisted_52 = { style: {"font-size":"12px","color":"gray","margin-bottom":"20px"} }
const _hoisted_53 = { style: {"font-size":"12px"} }
const _hoisted_54 = { class: "inputs-container" }
const _hoisted_55 = { class: "inputs-items" }
const _hoisted_56 = { class: "inputs-items-row" }
const _hoisted_57 = { class: "form-element" }
const _hoisted_58 = ["placeholder"]
const _hoisted_59 = { class: "form-element" }
const _hoisted_60 = { class: "inputs-items-row" }
const _hoisted_61 = { class: "form-element" }
const _hoisted_62 = ["placeholder"]
const _hoisted_63 = { class: "inputs-items-row" }
const _hoisted_64 = { class: "form-element" }
const _hoisted_65 = {
  value: "",
  disabled: ""
}
const _hoisted_66 = ["value", "id"]
const _hoisted_67 = { class: "form-element" }
const _hoisted_68 = ["placeholder"]
const _hoisted_69 = { style: {"display":"flex","justify-content":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _component_VueTelInput = _resolveComponent("VueTelInput")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!!_ctx.istanbulTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.sharePickupSelectable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass({ rond: true, validated: this.sharePickupLocation2 })
                }, _toDisplayString(this.sharePickupLocation2 ? "✓" : "!"), 3),
                (!this.sharePickupLocation2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      ((_ctx.istanbulTime as Date) < new Date('2023-06-28T00:00:00.000+03:00'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[0] || (_cache[0] = (e) => {
            e.preventDefault();
            this.showSicakPay = true;
          }
          )
                            }, _toDisplayString(_ctx.$t("sharePickup.value")), 1),
                            _hoisted_5,
                            _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.$t("Büyükbaş kurbanlıklardan hazırlanan 4 kg kemiksiz et paketini, bayramın 2. gününde gel - al noktalarımızdan teslim alabilirsiniz.")), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = e=> e.preventDefault())
                            }, _toDisplayString(_ctx.$t("Kurban Eti İkramı")), 1),
                            _hoisted_8,
                            _createElementVNode("small", _hoisted_9, _toDisplayString(_ctx.$t("Uygulamamızda talep süreci sona ermiştir. İlginiz için teşekkür ederiz.")), 1)
                          ]))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.$t('sharePickupResult', [this.sharePickupLocation2])
                      }, null, 8, _hoisted_11)
                    ]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "extras",
            style: _normalizeStyle(this.needySaved ? 'align-items: flex-start; ' : '')
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({ rond: true, validated: this.needySaved })
            }, _toDisplayString(this.needySaved ? "✓" : "!"), 3),
            (!this.needySaved)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  ((_ctx.istanbulTime as Date) < new Date('2023-06-29T00:00:00.000+03:00'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[2] || (_cache[2] = (e) => {
            e.preventDefault();
            this.showNeedy = true;
          })
                        }, _toDisplayString(_ctx.$t("İhtiyaç sahibi önerin")), 1),
                        _hoisted_14
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[3] || (_cache[3] = e=> e.preventDefault())
                        }, _toDisplayString(_ctx.$t("İhtiyaç sahibi önerin")), 1),
                        _hoisted_16,
                        _hoisted_17
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.$t('needySaved',
          [
            this.needy.FullName,
            this.needy.Telephone,
            this.needy.Address,
            this.needy.Town,
            this.needy.City
          ])
                  }, null, 8, _hoisted_19)
                ]))
          ], 4)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_BaseModal, {
      isShow: _ctx.showSicakPay,
      Size: "large",
      class: "no-print"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("h1", _hoisted_21, _toDisplayString(_ctx.$t("Kurban Eti İkramı Talep")), 1),
          _createElementVNode("label", _hoisted_22, [
            _hoisted_23,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Kurban Eti İkramı Almak İstiyorum")), 1)
          ]),
          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("Ödeme Bilgileri")), 1),
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("Formu dolduran kişi olarak size ait bilgileri giriniz")), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t(
              "(i) Ödeme öncesi işlemlerinizi kontrol ederek yeniden düzenleyebilirsiniz."
            )), 1),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, [
                _hoisted_30,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Hizmet Bedeli")), 1)
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tutar")) + " : ", 1),
              _hoisted_31
            ]),
            (_ctx.takePartZones && _ctx.takePartZones.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t("takePartZone.value").toUpperCase()), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.takePartZone) = $event)),
                      placeholder: "",
                      style: {"margin-bottom":"0"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.takePartZones, (zone, idx) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: zone,
                          key: idx
                        }, _toDisplayString(zone.name), 9, _hoisted_34))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.takePartZone]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("Adres")) + " : " + _toDisplayString(this.takePartZone && this.takePartZone.address), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("takePartZone.value").toUpperCase()), 1),
                    _createTextVNode(" " + _toDisplayString(this.takePartZone && this.takePartZone.address), 1)
                  ])
                ])),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("cardNumber.value")), 1),
                _withDirectives(_createElementVNode("input", {
                  ref: "myCardNumber",
                  placeholder: "1234 1234 1234 1234",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cardDetail.CardNumber) = $event)),
                  onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateCardNumber(_ctx.$refs.myCardNumber))),
                  onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onInputFocus(_ctx.cardDetail.CardNumber, this.$refs.myCardNumber))),
                  onBlur: _cache[8] || (_cache[8] = ($event: any) => (
                _ctx.onInputBlur(
                  _ctx.cardDetail.CardNumber,
                  _ctx.$refs.myCardNumber,
                  'CARDNUMBER'
                )
              ))
                }, null, 544), [
                  [_directive_maska, '#### #### #### ####'],
                  [_vModelText, _ctx.cardDetail.CardNumber]
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("cardholderName.value")), 1),
                _withDirectives(_createElementVNode("input", {
                  ref: "myCardFullName",
                  onKeypress: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.customMaska && _ctx.customMaska(...args))),
                  placeholder: _ctx.$t('fullname.value'),
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cardDetail.CardFullName) = $event)),
                  onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearInvalid(_ctx.$refs.myCardFullName))),
                  onFocus: _cache[12] || (_cache[12] = ($event: any) => (
                _ctx.onInputFocus(_ctx.cardDetail.CardFullName, this.$refs.myCardFullName)
              )),
                  onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onInputBlur(
  _ctx.cardDetail.CardFullName,
  _ctx.$refs.myCardFullName,
  'FULLNMAE'
)
))
                }, null, 40, _hoisted_42), [
                  [_vModelText, _ctx.cardDetail.CardFullName]
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t("expiryDate.value")), 1),
                  _withDirectives(_createElementVNode("input", {
                    ref: "myCardExpiry",
                    placeholder: "MM / YY",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.cardDetail.CardExpiry) = $event)),
                    onKeyup: _cache[15] || (_cache[15] = ($event: any) => (_ctx.clearInvalid(_ctx.$refs.myCardExpiry))),
                    onFocus: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onInputFocus(_ctx.cardDetail.CardExpiry, this.$refs.myCardExpiry))),
                    onBlur: _cache[17] || (_cache[17] = ($event: any) => (
                  _ctx.onInputBlur(_ctx.cardDetail.CardExpiry, _ctx.$refs.myCardExpiry, 'MMYY')
                ))
                  }, null, 544), [
                    [_directive_maska, '## / ##'],
                    [_vModelText, _ctx.cardDetail.CardExpiry]
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t("cvc.value")), 1),
                  _withDirectives(_createElementVNode("input", {
                    ref: "myCardCvc",
                    placeholder: "123",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.cardDetail.CardCvc) = $event)),
                    onKeyup: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clearInvalid(_ctx.$refs.myCardCvc))),
                    onFocus: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onInputFocus(_ctx.cardDetail.CardCvc, this.$refs.myCardCvc))),
                    onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onInputBlur(_ctx.cardDetail.CardCvc, _ctx.$refs.myCardCvc, 'CVC')))
                  }, null, 544), [
                    [_directive_maska, '####'],
                    [_vModelText, _ctx.cardDetail.CardCvc]
                  ])
                ])
              ])
            ]),
            _createElementVNode("label", _hoisted_46, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.hizmetKabul) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.hizmetKabul]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("Hizmet bedeli ödeme şartlarını kabul ediyorum")), 1)
            ], 512),
            (!!_ctx.stripeErrorText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.stripeErrorText), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_BaseButton, {
                class: "btn-lg-d-block",
                text: _ctx.submitBtnText,
                size: "small",
                onOnSubmit: _cache[23] || (_cache[23] = ($event: any) => (this.pay())),
                disabled: _ctx.disableBtn
              }, null, 8, ["text", "disabled"]),
              _createVNode(_component_BaseButton, {
                class: "btn-lg-d-block",
                text: _ctx.$t('İPTAL'),
                gray: true,
                size: "small",
                onOnSubmit: _cache[24] || (_cache[24] = ($event: any) => (this.showSicakPay = false))
              }, null, 8, ["text"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShow"]),
    _createVNode(_component_BaseModal, {
      isShow: _ctx.showNeedy,
      Size: "large",
      class: "no-print"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("h1", _hoisted_50, _toDisplayString(_ctx.$t("İhtiyaç Sahibi Öner")), 1),
          _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t("İletişim Bilgisi")), 1),
          _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("Formu dolduran kişi olarak ihtiyaç sahibinin bilgilerini giriniz")), 1),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.needy.FullName) = $event)),
                      placeholder: _ctx.$t('fullname.value'),
                      class: _normalizeClass({ invalid: _ctx.needyValidation.FullName })
                    }, null, 10, _hoisted_58), [
                      [_vModelText, _ctx.needy.FullName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_VueTelInput, _mergeProps({
                      ref: "myTelInput",
                      onInput: _ctx.onInput,
                      value: _ctx.needy.Telephone
                    }, _ctx.inputOpts2, {
                      modelValue: _ctx.needy.Telephone,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.needy.Telephone) = $event)),
                      dynamicPlaceholder: _ctx.$t('mobilephone.value'),
                      class: { invalid: _ctx.needyValidation.Telephone }
                    }), null, 16, ["onInput", "value", "modelValue", "dynamicPlaceholder", "class"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.needy.Address) = $event)),
                      placeholder: _ctx.$t('Adres'),
                      style: {"width":"624px","height":"initial"},
                      rows: "4",
                      class: _normalizeClass({ invalid: _ctx.needyValidation.Address })
                    }, null, 10, _hoisted_62), [
                      [_vModelText, _ctx.needy.Address]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.needy.City) = $event)),
                      ref: "cityInput",
                      onChange: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.citySelect && _ctx.citySelect(...args))),
                      class: _normalizeClass({ invalid: _ctx.needyValidation.City })
                    }, [
                      _createElementVNode("option", _hoisted_65, _toDisplayString(_ctx.$t("city.value")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statesOpts, (state, idx) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: state.name,
                          id: state.id,
                          key: idx
                        }, _toDisplayString(state.name), 9, _hoisted_66))
                      }), 128))
                    ], 34), [
                      [_vModelSelect, _ctx.needy.City]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.needy.Town) = $event)),
                      placeholder: _ctx.$t('town.value'),
                      ref: "townInput",
                      class: _normalizeClass({ invalid: _ctx.needyValidation.Town })
                    }, null, 10, _hoisted_68), [
                      [_vModelText, _ctx.needy.Town]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createVNode(_component_BaseButton, {
                class: "btn-lg-d-block",
                text: _ctx.$t('submit.value'),
                size: "small",
                onOnSubmit: _cache[31] || (_cache[31] = ($event: any) => (this.needySave()))
              }, null, 8, ["text"]),
              _createVNode(_component_BaseButton, {
                class: "btn-lg-d-block",
                text: _ctx.$t('İPTAL'),
                gray: true,
                size: "small",
                onOnSubmit: _cache[32] || (_cache[32] = ($event: any) => (this.showNeedy = false))
              }, null, 8, ["text"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShow"])
  ]))
}